import * as S from './styles';
import { PropsWithChildren } from 'react';

export type HeaderMenuLateralProps = PropsWithChildren<{
  $variant: 'solid' | 'translucent';
  $color: 'neutral' | 'accent';
}>;

export default function HeaderMenuLateral(props: HeaderMenuLateralProps) {
  const { children } = props;

  return <S.Container {...props}>{children}</S.Container>;
}
